import React from "react";
import { useState, useRef, useEffect, useMemo } from "react";
import {
    Box, Typography, Avatar, Chip, Button, IconButton, Grid, TextField,
    Stack, Popper, Grow, Paper, ClickAwayListener, Tabs, Tab, Menu, MenuItem, Collapse
} from "@mui/material";
import moment from "moment";
import TableComponent from "components/grid";
import StatusBadge from "components/badge/StatusBadge";
import CustomPagination from "components/CustomPagination";
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg";
import { LuEye, LuRefreshCw, LuSearch } from "react-icons/lu";
import { BiListUl } from "react-icons/bi";
import { MdOutlineFileDownload, MdOutlineFilterAlt } from "react-icons/md";
import { FaPlus } from "react-icons/fa6";
import Select from "react-select";
import CustomButton from "components/Button";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useGetAllContactsQuery, } from "store/slices/apis/contactSlice";
import { usePermission } from "hooks/usePermission";
import { LEGAL_TRACKER_CREATE, LEGAL_TRACKER_EDIT, LEGAL_TRACKER_VIEW } from "helpers/permissionConfig";
import AddLegal from "./addLegal";
import ViewLegal from "./viewLegal";
import EditLegal from "./editLegal";
import { useGetAllLegalCountQuery, useLazyGetAllLegalQuery, useLazyGetExportAllLegalQuery } from "store/slices/apis/legalTrackerSlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import ImageSlider from "./ImageSlider";
import { exportToExcel } from "utils/ExportToExcel";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { DEFAULT_DATE_FORMAT } from "config";
import { useDispatch } from "store";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import TrackerPageHeader from "components/TrackerPageHeader";

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

// const statusOptions = [
//     { label: "Complied", value: "Complied" },
//     { label: "Not Complied", value: "Not Complied" },
//     { label: "Not Applicable", value: "Not Applicable" }
// ]


const LEGAL_TYPES = [
    { label: "WC & Migrant Worker", value: "WMW" },
    { label: "CEA", value: "CEA" },
    { label: "Environment", value: "Environment" },
    { label: "Motor Vehicle Act", value: "MVA" },
];



const LegalTracker = () => {

    const { projectId } = useParams();
    const dispatch = useDispatch()

    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortOrder, setSortOrder] = useState('desc');
    const [sortBy, setSortBy] = useState('createdDate');
    const module = "legal Compliance"


    const [open, setOpen] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const anchorRef = useRef(null);
    const [isAdd, setIsAdd] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedData, setSelectedData] = useState(null);
    const [isView, setIsView] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [showSummary, setShowSummary] = useState(true);
    const [files, setFiles] = useState([]);
    const [title, setTitle] = useState(null);
    const [show, setShow] = useState(false);

    const createAccess = usePermission(LEGAL_TRACKER_CREATE);
    const editAccess = usePermission(LEGAL_TRACKER_EDIT);
    const viewAccess = usePermission(LEGAL_TRACKER_VIEW);
    const req = {
        projectId: projectId
    }

    const { data: contactsData, isLoading, error } = useGetAllContactsQuery();
    const [trigger, { data: legalData, isLoading: isloading, isFetching }] = useLazyGetAllLegalQuery()
    const { data: countData, refetch: refetchCounts } = useGetAllLegalCountQuery(req);
    const { data: statusData } = useGetMasterDataQuery({ module: module, category: 'StatusofCompliance', ProjectId: projectId });


    const responsibilityOption = legalData?.data
        ?.filter(item => item.responsibility && item.responsibility.trim() !== "")
        .map(item => ({
            label: item.responsibility,
            value: item.responsibility
        }));

    const statusOptions = statusData?.data?.map((item) => ({
        label: item?.value,
        value: item?.value
    })) || [];

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchTerm !== filters.SearchTerm) {
                const updatedFilters = {
                    ...filters,
                    SearchTerm: searchTerm,
                    PageNumber: 1,
                };
                setFilters(updatedFilters);
                trigger(updatedFilters);
                setPageNumber(1);
            }
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);


    const responsiblePersonOptions = React.useMemo(() => {
        if (!contactsData?.data) return [];

        return contactsData.data.map((item) => ({
            value: item.email,
            label: `${item.name}`,
        }));
    }, [contactsData]);


    const handleMenuOpen = (event, row) => {
        event.stopPropagation();
        setMenuAnchorEl(event.currentTarget);
        setMenuRow(row);
    };


    const handleMenuClose = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };


    const handleMenuView = () => {
        if (menuRow) {
            handleViewClick(menuRow);
        }
        handleMenuClose();
    };


    const handleMenuEdit = () => {
        if (menuRow) {
            handleEdit(menuRow);
        }
        handleMenuClose();
    };


    const { data: legalTrackerData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

    const [filters, setFilters] = useState({
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        ProjectId: projectId,
        SearchTerm: "",
        type: "BOCW"
    });



    useEffect(() => {
        trigger(filters);
    }, []);


    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);

        const updatedFilters = {
            ...filters,
            PageNumber: 1,
            ...(newValue > 0 ? { type: LEGAL_TYPES[newValue - 1]?.value } : {}),
        };

        if (newValue === 0 && updatedFilters.type) {
            updatedFilters.type = "BOCW";
        }

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
    };


    const handleApplyFilters = () => {
        const updatedFilters = {
            ...filters,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleReset = () => {
        const resetFilters = {
            ProjectId: projectId,
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
        };
        setFilters(resetFilters);
        trigger(resetFilters);
        setPageNumber(1);
        handleClose();
    };


    const handleSelectChange = (selectedOption, fieldName) => {
        const updatedFilters = {
            ...filters,
            [fieldName]: selectedOption?.value || "",
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };


    const handleDateChange = (e) => {
        const { name, value } = e.target;

        let utcDate = "";
        if (value) {

            const localDate = new Date(value);
            utcDate = localDate.toISOString();
        }

        const updatedFilters = {
            ...filters,
            [name]: utcDate,
            PageNumber: 1,
        };

        setFilters(updatedFilters);
        // trigger(updatedFilters);
        // setPageNumber(1);
    };


    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };


    const handleDelete = (filterType) => {
        const updatedFilters = {
            ...filters,
            [filterType]: "",
            PageNumber: 1
        };

        setFilters(updatedFilters);
        trigger(updatedFilters);
        setTabValue(0)
        setPageNumber(1);
    };


    const handleAddIncident = () => {
        setIsAdd((prev) => !prev);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleEdit = async (row) => {

        try {

            setSelectedData(row);
            setIsEdit((prev) => !prev);

        } catch (error) {

            console.error('Error fetching design by ID:', error);
            setIsEdit((prev) => !prev);
            setSelectedData(row);
        }
    };


    const handleEditClose = () => {
        setIsEdit((prev) => !prev);
        setSelectedData(null);
    };

    const handleViewClick = async (row) => {
        try {
            setViewData(row);
            setIsView(true);

        } catch (error) {
            setViewData(row);
            setIsView(true);
        }
    };


    const handleViewClose = () => {
        setIsView(false);
        setViewData(null);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };


    const tabs = [
        { label: "BOCW", value: "BOCW" },
        { label: "WC & Migrant Worker", value: "WMW" },
        { label: "CEA", value: "CEA" },
        { label: "Environment", value: "Environment" },
        { label: "Motor Vehicle Act", value: "MVA" },
    ]


    const getCount = (value) => {
        const count = countData?.data?.typeCounts
            ?.find((item) => item.type === value)?.count || 0;
        return count
    }





    const highlightText = (text, highlight) => {
        if (!highlight || !text) return text;

        const regex = new RegExp(`(${highlight})`, 'gi');
        const parts = String(text).split(regex);

        return parts.map((part, index) =>
            regex.test(part) ? (
                <span
                    key={index}
                    style={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        padding: '0 2px',
                        borderRadius: '3px'
                    }}
                >
                    {part}
                </span>
            ) : part
        );
    };



    const handleToggleSummary = () => {
        setShowSummary((prev) => !prev);
    };

    const handlePhotographClick = (images, heading) => {
        setFiles(images);
        setTitle(heading);
        setShow(true);
    }

    const handlePhotographClose = () => {
        setFiles([]);
        setTitle(null);
        setShow(false)
    }

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const ALL_EXPORT_COLUMNS = [
        { name: "Category", field: "category" },
        { name: "Section/Rule/Clause", field: "sectionRuleClause" },
        { name: "Applicable requirement of the section/Rules/Clause", field: "applicableRequirement" },
        { name: "Requirement of Compliance", field: "requirementOfCompliance" },
        { name: "Compliance Frequency", field: "complianceFrequency" },
        { name: "Responsibility", field: "responsibility" },
        { name: "Status of Compliance", field: "statusOfCompliance" },
        { name: "Compliance Evidence", field: "complianceEvidence" },
        { name: "Remarks", field: "remarks" },
    ];

    const [triggerExport, { isFetching: isExporting }] = useLazyGetExportAllLegalQuery();

    const handleExportExcel = async () => {
        try {
            const exportFilters = {
                ...filters,
                PageNumber: 1,
                PageSize: 5000,
            };

            const response = await triggerExport(exportFilters).unwrap();
            const rows = response?.data || [];

            if (!Array.isArray(rows) || rows.length === 0) {
                openNotification("No data available to export", "warning");
                return;
            }

            const formattedData = rows.map((row, index) => {
                const rowData = { "S.No": index + 1 };

                ALL_EXPORT_COLUMNS.forEach(col => {
                    const field = col.field;
                    let value = "N/A";
                    const raw = row[field];

                    if (field === "complianceEvidence") {
                        if (Array.isArray(raw) && raw.length > 0) {
                            value = raw
                                .map(img => img?.filePath)
                                .filter(Boolean)
                                .join(", ");
                        } else {
                            value = "N/A";
                        }
                    }


                    else {
                        value = raw ?? "N/A";
                    }

                    rowData[col.name] = value;
                });

                return rowData;
            });

            exportToExcel(formattedData, "Legal_Compliance_Data", "Legal Compliance");

            openNotification("Excel exported successfully", "success");
        } catch (error) {
            console.error("Export error:", error);
            openNotification("Failed to export Excel", "error");
        }
    };



    const columns = [
        {
            name: "",
            field: "actions",
            width: "10px",
            sticky: true,
            renderer: (row) => (
                <>
                    {(viewAccess || editAccess) &&
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                            >
                                <MoreVertIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    }
                </>

            ),
        },
        {
            name: "ID",
            field: "legalId",
            width: "100px",
            sticky: true,
            renderer: (row) => (
                <>
                    {row?.legalId ? row?.legalId : '-'}
                </>
            ),
        },
        {
            name: "Category",
            field: "category",
            width: "200px",
            sticky: true,
            renderer: (row) => (
                <Box
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {row.category || "N/A"}
                </Box>
            )

        },

        {
            name: "Section/Rule/Clause",
            field: "sectionRuleClause",
            width: "200px",
            sticky: true,
            renderer: (row) => (
                <Box
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {highlightText(row.sectionRuleClause, searchTerm) || "N/A"}
                </Box>
            )

        },

        {
            name: "Applicable requirement of the section/Rules/Clause",
            field: "applicableRequirement",
            width: "300px",
            renderer: (row) => (
                <Box
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {row.applicableRequirement || "N/A"}
                </Box>
            )
        },
        {
            name: "Requirement of Compliance",
            field: "requirementOfCompliance",
            width: "200px",
            renderer: (row) => (
                <Box
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {highlightText(row.requirementOfCompliance, searchTerm) || "N/A"}
                </Box>
            )
        },
        {
            name: "Compliance Frequency",
            field: "complianceFrequency",
            width: "250px",
            renderer: (row) => (
                <Box
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {row.complianceFrequency || "N/A"}
                </Box>
            )
        },
        {
            name: "Responsibility",
            field: "responsibility",
            width: "200px",
            renderer: (row) => (
                <Box
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {row.responsibility || "N/A"}
                </Box>
            )
        },
        {
            name: "Status of Compliance",
            field: "statusOfCompliance",
            renderer: (row) => (
                <Box
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {row.statusOfCompliance || "N/A"}
                </Box>
            )
        },
        {
            name: "Compliance Evidence",
            field: "complianceEvidence",
            width: "120px",
            renderer: (row) => {
                const images = row?.complianceEvidence || [];
                return <Box
                    display="flex"
                    gap={0.5}
                    flexWrap="wrap"
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {images.length > 0 ? (
                        images.slice(0, 1).map((file, index) => (
                            <Box key={index}>
                                <img
                                    src={file?.filePath}
                                    alt="img"
                                    width={80}
                                    height={80}
                                    style={{
                                        objectFit: "cover",
                                        borderRadius: "3px",
                                        border: "1px solid #ddd",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => handlePhotographClick(images, "Compliance Evidence")}
                                />
                            </Box>
                        ))
                    ) : (
                        <Typography variant="caption">N/A</Typography>
                    )}
                </Box>
            }
        },
        {
            name: "Remarks",
            field: "remarks",
            width: "300px",
            renderer: (row) => (
                <Box
                    sx={{
                        whiteSpace: "pre-line",
                    }}
                >
                    {row.remarks || "N/A"}
                </Box>
            )
        },

    ];


    return (
        <>
            <TrackerPageHeader title="Legal Compliance Tracker" description="Monitor legal obligations, responsibility, and compliance status.">
                <ProjectLastUpdatedOn date={legalTrackerData?.compliance} />
            </TrackerPageHeader>
            <Grid container spacing={2} sx={{ p: 2 }}>


                <Grid size={12}>
                    <Box
                        sx={{
                            width: "100%",
                            borderBottom: "2px solid #ECECEC",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            p: 0,
                            display: "flex", alignItems: "center", justifyContent: 'space-between',
                            "-webkit-overflow-scrolling": "touch",
                        }}
                    >
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            TabIndicatorProps={{ style: { display: "none" } }}
                            variant="scrollable"
                            scrollButtons={false}
                            sx={{
                                justifyContent: "flex-start !important",
                                alignItems: "flex-start",
                                "& .MuiTabs-flexContainer": {
                                    justifyContent: "flex-start !important",
                                    gap: "30px",
                                },
                            }}
                        >
                            {tabs.map((item, index) => {
                                return (
                                    <Tab
                                        key={index}
                                        label={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <Typography
                                                    sx={{
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        lineHeight: "100%",
                                                        color: tabValue === index ? "#0E73F6" : "#7E7E7E",
                                                        fontFamily: "Outfit, sans-serif"
                                                    }}
                                                >
                                                    {item.label}
                                                </Typography>

                                                <Chip
                                                    label={getCount(item.value)}
                                                    sx={{
                                                        height: "20px",
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        lineHeight: 1,
                                                        backgroundColor: "#E5E9EB",
                                                        color: "#5F5F5F",
                                                    }}
                                                />


                                            </Box>
                                        }
                                        sx={{
                                            textTransform: "none",
                                            minWidth: "auto",
                                            paddingBottom: "14px",
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                            borderBottom: tabValue === index ? "2px solid #0E73F6" : "2px solid transparent",
                                        }}
                                    />
                                );
                            })}
                        </Tabs>
                        {createAccess &&
                            <CustomButton
                                label="Create Legal"
                                startIcon={<FaPlus />}
                                color="primary"
                                onClick={handleAddIncident}
                                sx={{
                                    backgroundColor: "#2563EB",
                                    fontFamily: 'Outfit',
                                    fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '100%',
                                    letterSpacing: '0px',
                                }}
                            />
                        }
                    </Box>
                </Grid>


                <Grid size={12}>
                    <Grid container>
                        <Grid size={{ md: 8, sm: 12 }}>
                            <Stack
                                direction="row"
                                spacing={1}
                                flexWrap="wrap"
                                sx={{
                                    padding: "8px 0",
                                    alignItems: "center",
                                    minHeight: "40px"
                                }}
                            >

                                {filters.Responsibility && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Responsibility:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.Responsibility}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Responsibility')}
                                    />
                                )}



                                {filters.StatusOfCompliance && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Status Of Compliance:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>
                                                    {filters.StatusOfCompliance}
                                                </span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('StatusOfCompliance')}
                                    />
                                )}

                            </Stack>
                        </Grid>


                        <Grid size={{ md: 4, sm: 12 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: { md: "row", xs: "column" },
                                    alignItems: { md: "center", xs: "flex-start" },
                                    justifyContent: 'end',
                                    p: "8px 0px"
                                }}
                            >
                                <TextField
                                    placeholder="Search By RequirementOfCompliance & SectionRuleClause"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        startAdornment: <LuSearch style={{ marginRight: '8px', color: '#6B7280' }} />,
                                    }}
                                    sx={{
                                        minWidth: { md: '450px', xs: "auto" },
                                        backgroundColor: '#fff',
                                        '& .MuiOutlinedInput-root': { borderRadius: '3px', minHeight: '36px', fontSize: '13px' },
                                        '& .MuiInputBase-input::placeholder': {
                                            fontSize: '0.9rem',
                                        }
                                    }}
                                    type="search"
                                />
                                <IconButton
                                    ref={anchorRef}
                                    onClick={handleToggle}
                                >
                                    <MdOutlineFilterAlt size={24} color="#48535B" />
                                </IconButton>
                                <IconButton onClick={handleExportExcel} disabled={isExporting}>
                                    <MdOutlineFileDownload size={24} color="#48535B" />
                                </IconButton>


                                <Popper
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    placement="bottom-end"
                                    transition
                                    disablePortal={false}
                                    sx={{ zIndex: 2000 }}
                                >
                                    {({ TransitionProps }) => (
                                        <Grow {...TransitionProps}>
                                            <Paper
                                                sx={{
                                                    mt: 1,
                                                    p: 2,
                                                    borderRadius: 1,
                                                    boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                    width: 600,
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <Box>
                                                        <Grid container spacing={2}>

                                                            {/* <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Contractor Name</Typography>
                                                                <Select
                                                                    name="ContractorName"
                                                                    options={responsiblePersonData}
                                                                    placeholder="Select Contractor"
                                                                    onChange={(option) => handleSelectChange(option, "ContractorName")}
                                                                    value={responsiblePersonData.find(option => option.value === filters.ContractorName) || null}
                                                                />
                                                            </Grid> */}

                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Responsibility</Typography>
                                                                <Select
                                                                    name="Responsibility"
                                                                    options={responsibilityOption}
                                                                    placeholder="Select Responsibility"
                                                                    onChange={(option) => handleSelectChange(option, "Responsibility")}
                                                                    value={responsibilityOption.find(option => option.value === filters.Responsibility) || null}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Status Of Compliance</Typography>
                                                                <Select
                                                                    name="StatusOfCompliance"
                                                                    options={statusOptions}
                                                                    placeholder="Select Status Of Compliance"
                                                                    onChange={(option) => handleSelectChange(option, "StatusOfCompliance")}
                                                                    value={statusOptions.find(option => option.value === filters.StatusOfCompliance) || null}
                                                                />
                                                            </Grid>



                                                            {/* <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Incident To Date</Typography>
                                                                <TextField
                                                                    type="date"
                                                                    name="DateOfIncidentTo"
                                                                    value={filters.DateOfIncidentTo ? new Date(filters.DateOfIncidentTo).toISOString().split('T')[0] : ""}
                                                                    onChange={handleDateChange}
                                                                    onClick={(e) => {
                                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                        if (input) input.showPicker?.();
                                                                    }}
                                                                    fullWidth
                                                                    sx={{
                                                                        "& input::-webkit-calendar-picker-indicator": {
                                                                            display: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& input[type='date']": {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "& fieldset": {
                                                                                border: "none",
                                                                            },
                                                                        },
                                                                    }}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                            >
                                                                                {calenderSVG}
                                                                            </Box>
                                                                        ),
                                                                        sx: {
                                                                            backgroundColor: "#E7E7EB",
                                                                            height: "40px",
                                                                            width: { xs: "100%", md: "100%" },
                                                                            borderRadius: "3px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid> */}

                                                            <Grid size={12}>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Button onClick={handleReset}
                                                                        sx={{
                                                                            textTransform: "none",
                                                                            color: "#F15744",
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            borderRadius: "3px",
                                                                            fontWeight: 500,
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}>
                                                                        Reset
                                                                    </Button>
                                                                    <Button
                                                                        type="button"
                                                                        onClick={handleApplyFilters}
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: "#2563EB",
                                                                            borderRadius: "3px",
                                                                            textTransform: "none",
                                                                            fontWeight: 500,
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            color: "#FFFFFF",
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}
                                                                    >
                                                                        Apply
                                                                    </Button>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>

                                <IconButton
                                    onClick={() => trigger(filters)}
                                >
                                    <LuRefreshCw size={20} color="#48535B" />
                                </IconButton>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid size={12}>
                    <TableComponent
                        columns={columns}
                        data={legalData?.data || []}
                        createSortHandler={handleRequestSort}
                        isLoading={isFetching}
                        order={sortOrder}
                        orderBy={sortBy}

                    />
                    <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                mt: 1,
                                borderRadius: "3px",
                                minWidth: 140,
                                border: "1px solid #E5E9EB",
                                boxShadow: "0px 10px 30px rgba(15, 23, 42, 0.12)",
                                overflow: "hidden",
                            },
                        }}
                        MenuListProps={{
                            sx: {
                                py: 0.5,
                            },
                        }}
                    >
                        {viewAccess && <MenuItem
                            onClick={handleMenuView}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <LuEye size={16} style={{ color: "#4B5563" }} />
                            <span>View</span>
                        </MenuItem>
                        }
                        {editAccess && <MenuItem
                            onClick={handleMenuEdit}
                            sx={{
                                fontFamily: "Outfit, sans-serif",
                                fontSize: "14px",
                                fontWeight: 400,
                                px: 1.5,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                color: "#111827",
                                "&:hover": {
                                    backgroundColor: "#F6F8F9",
                                },
                            }}
                        >
                            <EditIcon style={{ width: 14, height: 14 }} />
                            <span>Edit</span>
                        </MenuItem>
                        }
                    </Menu>

                    <CustomPagination
                        totalCount={legalData?.totalRecords || 0}
                        pageSize={pageSize}
                        page={pageNumber}
                        onPageChange={handlePageChange}
                        setCurrentPage={setPageNumber}
                        onPageSizeChange={handlePageSizeChange}
                    />
                </Grid>
            </Grid>
            {isAdd && <AddLegal open={isAdd} handleClose={handleAddIncident} refetchCounts={refetchCounts} />}
            {isEdit && <EditLegal open={isEdit} handleClose={handleEdit} rowData={selectedData} refetchCounts={refetchCounts} />}
            {isView && <ViewLegal open={isView} handleClose={handleViewClose} rowData={viewData} />}
            <ImageSlider open={show} handleClose={handlePhotographClose} files={files} title={title} />
        </>
    );
}

export default LegalTracker;
